<template>
    <div>
        <!-- Titre primaire/secondaire -------------------------------------------------------------->
        <el-row>
            <el-col :md="12" :sm="12" :xs="24" class="primSecondFont hidden-xs-only">PRIMAIRE</el-col>
            <el-col :md="12" :sm="12" :xs="24" class="secondPos primSecondFont hidden-xs-only">SECONDAIRE</el-col>
        </el-row>

        <!-- Boutons -------------------------------------------------------------------------------->
        <el-row>
            <!-- Boutons du primaire-->
            <el-col :md="10" :sm="8" :xs="24" class="primPos">
                <el-button-group tabPosition="left">
                    <el-button size="medium" v-bind:class="focusA" class="btn-select colorA" @click="showContent('colorA','detailA')" title="Voies Respiratoires" >A</el-button>
                    <el-button size="medium" v-bind:class="focusB" class="btn-select colorB" @click="showContent('colorB','detailB')" title="Breathing" >B</el-button>
                    <el-button size="medium" v-bind:class="focusC" class="btn-select colorC" @click="showContent('colorC','detailC')" title="Circulation">C</el-button>
                    <el-button size="medium" v-bind:class="focusD" class="btn-select colorD" @click="showContent('colorD','detailD')" title="Disability">D</el-button>
                    <el-button size="medium" v-bind:class="focusE" class="btn-select colorE" @click="showContent('colorE','detailE')" title="Exposure" >E</el-button>
                </el-button-group>
            </el-col>
            <!-- Boutons du primaire/secondaire-->
            <el-col :md="14" :sm="16" :xs="24" class="secondPos">
                <el-button-group>
                    <el-button v-if="this.checkup.versionV2" size="medium" v-bind:class="focusS1" class="second-btn btn-select colorS" @click="showContent('colorS','detailS1')" title="SAMPLER" >S<span class="hidden-xs-only">AMPLER</span></el-button>
                    <el-button v-else size="medium" v-bind:class="focusS1" class="second-btn btn-select colorS" @click="showContent('colorS','detailS1')" title="SAMPLE" >S<span class="hidden-xs-only">AMPLE</span></el-button>
                    <el-button size="medium" v-bind:class="focusS2" class="second-btn btn-select colorS" @click="showContent('colorS','detailS2')" title="OPQRST" >O<span class="hidden-xs-only">PQRST</span></el-button>
                    <el-button v-if="!this.checkup.versionV2" size="medium" v-bind:class="focusS3" class="second-btn btn-select colorS" @click="showContent('colorS','detailS3')" title="FAST" >F<span class="hidden-xs-only">AST</span></el-button>
                    <el-button size="medium" v-bind:class="focusS4" class="second-btn btn-select colorS" @click="showContent('colorS','detailS4')" title="LESIONS" >L<span class="hidden-xs-only">ESIONS</span></el-button>
                    <el-button size="medium" v-bind:class="focusS5" class="second-btn btn-select colorS" @click="showContent('colorS','detailS5')" title="DAE" >D<span class="hidden-xs-only">AE</span></el-button>
                    <el-button size="medium" v-if="column.s6Visible" v-bind:class="focusS6" class="second-btn btn-select colorS" @click="showContent('colorS','detailS6')" title="Grossesse" >G<span class="hidden-xs-only">ROSSESSE</span></el-button>
                </el-button-group>
            </el-col>
        </el-row>

        <el-divider></el-divider>

        <!-- Corps -------------------------------------------------------------------------------->
        <!-- Cas Général -->
        <CheckupTab v-if="focusS4 == ''"  v-bind="{column:column, parameters:parameters}"/>
        <!-- Cas Lésions -->
        <CheckupLesion  v-else  v-bind="{column:column, parameters:parameters}"/>

    </div>
</template>

<script>
    import CheckupTab from '@/components/checkup.detail.tab.component.vue';
    import CheckupLesion from '@/components/checkup.detail.lesion.component.vue';


    export default {
        name: 'CheckupPart2',
        props: ['checkup','column'],
       
        components: {
            CheckupTab,
            CheckupLesion
        },

        data() {
            return {
                parameters:{
                    withTitle: true,
                    classColor: 'colorA',
                    borderLeft : 'border-l',
                    borderRight : 'border-r',
                    nameArea : ''
                    },
                focusA : 'focus',
                focusB : '',
                focusC : '',
                focusD : '',
                focusE : '',
                focusS1 : '',
                focusS2 : '',
                focusS3 : '',
                focusS4 : '',
                focusS5 : '',
                focusS6 : ''
            };
        },


        methods: { 
            showContent(x, dataType) {        
                this.parameters.classColor = x;
                this.focusA = '';
                this.focusB = '';
                this.focusC = '';
                this.focusD = '';
                this.focusE = '';
                this.focusS1 = '';
                this.focusS2 = '';
                this.focusS3 = '';
                this.focusS4 = '';
                this.focusS5 = '';
                this.focusS6 = '';
                this.parameters.borderLeft = 'border-l';
                this.parameters.borderRight = 'border-r';
                switch (dataType) {
                    case 'detailA':
                        this.parameters.withTitle = true;
                        this.column.col01 = this.checkup.a.child1;
                        this.column.col02 = this.checkup.a.child2;
                        this.column.col03 = this.checkup.a.child3;
                        this.column.leftTitle = this.checkup.a.libelle;
                        this.focusA = 'focus';
                        break;
                    case 'detailB':
                        this.parameters.withTitle = true;
                        this.column.col01 = this.checkup.b.child1;
                        this.column.col02 = this.checkup.b.child2;
                        this.column.col03 = this.checkup.b.child3;
                        this.column.leftTitle = this.checkup.b.libelle;		  
                        this.focusB = 'focus';
                        break;
                    case 'detailC':
                        this.parameters.withTitle = true;
                        this.column.col01 = this.checkup.c.child1;
                        this.column.col02 = this.checkup.c.child2;
                        this.column.col03 = this.checkup.c.child3;
                        this.column.leftTitle = this.checkup.c.libelle;
                        this.focusC = 'focus';
                        break;
                    case 'detailD':
                        this.parameters.withTitle = true;
                        this.column.col01 = this.checkup.d.child1;
                        this.column.col02 = this.checkup.d.child2;
                        this.column.col03 = this.checkup.d.child3;
                        this.column.leftTitle = this.checkup.d.libelle;
                        this.focusD = 'focus';
                        break;
                    case 'detailE':
                        this.parameters.withTitle = true;
                        this.column.col01 = this.checkup.e.child1;
                        this.column.col02 = this.checkup.e.child2;
                        this.column.col03 = this.checkup.e.child3;
                        this.column.leftTitle = this.checkup.e.libelle;
                        this.focusE = 'focus';
                        break;
                    case 'detailS1':
                        this.parameters.withTitle = false;
                        this.column.col01  = this.checkup.s1.child1;
                        this.column.col02 = this.checkup.s1.child2;
                        this.column.col03 = this.checkup.s1.child3;
                        this.column.leftTitle = this.checkup.s1.libelle;
                        this.focusS1 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    case 'detailS2':
                       
                        this.parameters.withTitle = false;
                        this.column.col01  = this.checkup.s2.child1;
                        this.column.col02 = this.checkup.s2.child2;
                        this.column.col03 = this.checkup.s2.child3;
                        this.column.leftTitle = this.checkup.s2.libelle;
                        this.focusS2 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    case 'detailS3':
                        this.parameters.withTitle = false;
                        this.column.col01  = this.checkup.s3.child1;
                        this.column.col02 = this.checkup.s3.child2;
                        this.column.col03 = this.checkup.s3.child3;
                        this.column.leftTitle = this.checkup.s3.libelle;
                        this.focusS3 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    case 'detailS4':
                        this.parameters.withTitle = false;
                        this.column.col01 = this.checkup.s4.child1;
                        this.column.col02 = this.checkup.s4.child2;
                        this.column.col03 = this.checkup.s4.child3;
                        this.column.leftTitle = this.checkup.s4.libelle;
                        this.column.gender = this.checkup.gender;
                        this.focusS4 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    case 'detailS5':
                        this.parameters.withTitle = false;
                        this.column.col01 = this.checkup.s5.child1;
                        this.column.col02 = this.checkup.s5.child2;
                        this.column.col03 = this.checkup.s5.child3;
                        this.column.leftTitle = this.checkup.s5.libelle;
                        this.focusS5 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    case 'detailS6':
                        this.parameters.withTitle = false;
                        this.column.col00 = this.checkup.s6.child0;
                        this.column.col01 = this.checkup.s6.child1;
                        this.column.col02 = this.checkup.s6.child2;
                        this.column.col03 = this.checkup.s6.child3;
                        this.column.leftTitle = this.checkup.s6.libelle;
                        this.focusS6 = 'focus';
                        this.parameters.borderLeft = '';
                        this.parameters.borderRight = '';
                        break;
                    default:
                        this.parameters.withTitle = false;
                        break;
                }
            },
        }
        
    };
</script>

<style scoped>

/*   Primaire et secondaire  
     ---------------------------------------------
*/
    .primSecondFont{
        padding-bottom: 7px;
    }

    .btn-select.focus{
        margin-top: -7px;
        color: #000000;
    }   
  
/*   classe pour le mode smartphone 
     ---------------------------------------------
*/
@media only screen and (max-width: 992px) {
    .second-btn{
       padding-left: 9px;
       padding-right: 9px; 
    }
}



  @media only screen and (max-width: 767px) {   
    .btn-select:focus {
        margin-top: unset;
        height: unset;
        border-radius: 15px !important;
    }

    .second-btn{
       padding-left: 15px;
       padding-right: 15px; 
    } 

    .btn-select.focus{
        margin-top: unset;
        height: unset;
        border-radius: 20px !important;
        color: #000000;

    }
  }
</style>
